import React, { useId } from 'react';

import type { Swoop as Props } from './swoop.types';

const Swoop: React.FunctionComponent<Props> = props => {
  const gradientId = useId();

  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 1920 1080"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M-259.8 392.9C-259.8 392.9 522.3 1326.3 1132.9 1182.1C1658.8 1058 1374.1 -7.09998 943.9 252.3C484.7 529.1 1750.4 1462.4 1951 -90.9"
        stroke={`url(#${gradientId})`}
        strokeMiterlimit="10"
        strokeWidth="252"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={gradientId}
          x1="903.03"
          x2="742.044"
          y1="-205.562"
          y2="1300.26"
        >
          <stop stopColor="#e5231b" stopOpacity="0" />
          <stop offset="1" stopColor="#e5231b" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Swoop;
